import {Injectable} from "@angular/core";
import {CustomerModel, customerModelFactory} from "./customer.model";
import {HttpClient} from "@angular/common/http";
import {map} from "rxjs/operators";

const DEFAULT_PAGE = 1;
const DEFAULT_PAGE_LIMIT = 10;

export type CustomerServiceListResponse = {
  rows: CustomerModel[];
  count: number;
};

@Injectable()
export class CustomerService {
  private url: string = "/api/customer";

  list(page = DEFAULT_PAGE, limit = DEFAULT_PAGE_LIMIT, search = ""): Promise<CustomerServiceListResponse> {
    const params = {
      page: `${page}`,
      limit: `${limit}`,
      search: search ? `${search}` : "",
      sequence: "true",
    };

    return this.http.get<CustomerServiceListResponse>(`${this.url}/list`, {params})
      .pipe(map(json => ({rows: json.rows.map(customerModelFactory), count: +json.count})))
      .toPromise();
  }

  createCustomer(customer): Promise<CustomerModel> {
    return this.http.post(`${this.url}/create-customer`, {customer})
      .pipe(map(json => customerModelFactory(json)))
      .toPromise();
  }

  getCustomerById(id): Promise<any> {
    return this.http.get(`${this.url}/${id}`)
      .pipe(map(json => customerModelFactory(json)))
      .toPromise();
  }

  updateCustomerHeaders(customer): Promise<any> {
    return this.http.post(`${this.url}/update-customer-headers`, {customer})
      .toPromise();
  }

  constructor(private http: HttpClient) {}
}
